import { utcToZonedTime } from 'date-fns-tz'
import { add, addMinutes, isBefore, isAfter, isWithinInterval } from 'date-fns'

export function addRemoveFromArray(item, itemsArray, shouldAdd) {
  const alreadyInArray = itemsArray.includes(item)
  if (shouldAdd) {
    if (!alreadyInArray) { itemsArray = itemsArray.concat(item) }
  } else {
    if (alreadyInArray) { itemsArray = itemsArray.filter(function (itemInArray) { return itemInArray !== item }) }
  }
  return itemsArray
}

export function addRemoveObject(keyToUpdate, valueObjectToUpdate, objectToUpdate) {
  let updatedObject = objectToUpdate
  const objectIsEmpty = Object.keys(updatedObject).length < 1,
    valueIsEmpty = Object.keys(valueObjectToUpdate).length < 1

  if (objectIsEmpty && valueIsEmpty) {
  } else if (objectIsEmpty && !valueIsEmpty) {
    let updatedObject = {}
    updatedObject[keyToUpdate] = valueObjectToUpdate
    return updatedObject
  } else {
    for (let key in updatedObject) {
      if (key === keyToUpdate) {
        if (valueIsEmpty) {
          delete updatedObject[key]
        } else {
          updatedObject[key] = valueObjectToUpdate
        }
      }
    }
  }
  return updatedObject
}

export function groupBy(arrayToGroup, keyToGroupBy) {
  // from https://stackoverflow.com/questions/14446511
  return arrayToGroup.reduce(function(rv, x) {
    (rv[x[keyToGroupBy]] = rv[x[keyToGroupBy]] || []).push(x);
    return rv;
  }, {})
}

export function isObject(obj) {
  return typeof obj === 'function' || (typeof obj === 'object' && !!obj)
}

export function shortenNumber(number, useCurrency) {
  // from: https://stackoverflow.com/a/55987576
  let n = parseInt(number),
    isDecimal = number > 0 && number < 1,
    isNeg = n < 0,
    absNumber = Math.abs(n),
    shortNumber

  switch (true) {
    case (absNumber >= 1e3 && absNumber < 1e6):
      shortNumber = `${+(absNumber / 1e3).toFixed(1)}k`
      break
    case (absNumber >= 1e6 && absNumber < 1e9):
      shortNumber = `${+(absNumber / 1e6).toFixed(1)}m`
      break
    case (absNumber >= 1e9 && absNumber < 1e12):
      shortNumber = `${+(absNumber / 1e9).toFixed(1)}b`
      break
    case (absNumber >= 1e12):
      shortNumber = `${+(absNumber / 1e12).toFixed(1)}t`
      break
    default:
      shortNumber = isDecimal ? number.toFixed(2) : absNumber
  }

  let currencyNumber = isNeg ? `-$${shortNumber}` : `$${shortNumber}`
  shortNumber = isNeg ? `-${shortNumber}` : shortNumber
  return useCurrency ? currencyNumber : shortNumber
}

/**
 * Calculates the difference from a point on site to the top of an element
 * @param y {number} = A vertical point on the page
 * @param element {object|string} = DOM element or selector
 */
export function spaceBetween(y, element) {
  if(typeof element === 'string') {
    element = document.querySelector(element)
  }

  if(!element) {
    throw new Error(`Unable to find element for selector: ${selector}`)
  }

  const elementTop = element.getBoundingClientRect().top
  return elementTop - y
}
export function isNil(value) {
  return value === null || value === undefined
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3]
  }
  return null
}

export function isGifImage(imageFile) {
  const imageType = imageFile ? (imageFile.type || imageFile.file_name.toLowerCase()) : ''
  return imageType.includes('gif')
}

/**
 * Pluralize a given string
 * @param {number} value - value to control
 * @param {string} singular - desired singular version of string
 * @param {string} [plural] - desired plural version of string or "s" appended to singular if not provided
 * @returns pluralization
 */

export function pluralize(value, singular, plural = `${singular}s`) {
  const type = value == 1 ? singular : plural
  return type
}

/**
 * Returns the index of the blot when given a domNode
 * @param {string} text - text to be spliced
 * @param {number} index - index to insert text
 * @param {number} replacementString - text to be inserted
 */

export function spliceIntoString(text, index, replacementString){
  return index || index === 0 ? `${text.slice(0,index)} ${replacementString} ${text.slice(index)}` : text;
}

/**
* Returns the next available datetime when checking a given datetime range
* @param {string} timeZone - merchant's time zone
* @param {date} startTime - date object representing the start datetime
* @param {date} endTime - date object representing the end datetime
*/
export function isInDateTimeRangeUtil({timeZone, startHour, endHour, chosenDate = null, addBuffer = false}) {
  const now = chosenDate || utcToZonedTime(new Date(), timeZone),
        startTime = new Date(now.getTime())
  let endTime = new Date(now.getTime())
  startTime.setHours(startHour, 0, 0)
  endTime.setHours(endHour, 0, 0)

  // There are 2 scenarios:
  // If send now, merchant has the full window and 15 minute buffer (i.e. ad has 8PM-9PM, merchant is able to send now in between 8PM-9:15PM)
  // If send later, merchant has the full window without the buffer.
  addBuffer && (endTime = addMinutes(endTime, 15))
  return isWithinInterval(now, { start: startTime, end: endTime })
}

/**
* Checks if the merchant's current time is in the attached ad's send time range. If not, calculate the next available date time to send the campaign with attached ad.
* No need to worry about ads that start in the future cuz BE won't return those to FE.
* @param {string} timeZone - merchant's time zone
* @param {date} min - the start date of ad with time range (if there is any)
* @param {date} max - the end date of ad with time range (if there is any)
*/
export function getNextAvailableDateTimeUtil(timeZone, min, max) {
  const now = utcToZonedTime(new Date(), timeZone),
        endTime = new Date(now.getTime()),
        startTime = new Date(min.getTime())

  startTime.setHours(0)
  endTime.setHours(max.getHours(), 0, 0)

  const isInAdDateRange = isWithinInterval(now, { start: startTime, end: max })

  let nextAvailableDateTime = now

  if (isInAdDateRange) {
    if (isAfter(now, endTime)) nextAvailableDateTime = add(nextAvailableDateTime, { days: 1 })
    nextAvailableDateTime.setHours(min.getHours(), 0, 0, 0)
  }

  return nextAvailableDateTime
}

/**
 * Removes time zone part from date string aka anything after "Z".
 * @param {string} dateString - ISO string that needs time zone part removed
 */
export function removeTimeZoneAndGetDateUtil(dateString) {
  return dateString ? new Date(dateString.split("Z")[0]) : null
}

/*
 *  Removes http protocol from a given string
 *  @param {string} text - text to be stripped
 */
export function stripHttpProtocolUtil(text) {
  if(!text) return
  return text.replace(/(http|https):\/\//g, "")
}

/**
 * Move an array element from an index to an index
 * @param {array} arr
 * @param {number} fromIndex
 * @param {number} toIndex
 */
export function arrayMoveUtil(arr, fromIndex, toIndex) {
  var arrayElement = arr[fromIndex]
  arr.splice(fromIndex, 1)
  arr.splice(toIndex, 0, arrayElement)
  return arr
}

/**
 * Check if an url starts strictly with http:// or https://
 * @param {string} url
 * @returns {boolean} result of the regex as a boolean
 */
export function isUrlFormatValidUtil(url){
  const regex = new RegExp(/^(http|https):\/\/([a-z]|[A-Z]|[0-9])/g)
  return regex.test(url)
}